import { Pipe, PipeTransform } from '@angular/core';
import { CONSTANTS } from '@pk/powerkioskutils';

import _ from 'lodash';

import { Agent } from '../models';
import { LicensePlan } from '../models/license-plan';

@Pipe({
    name: 'licensePlanNameFilter',
    standalone: false
})
export class LicensePlanNameFilterPipe implements PipeTransform {
	// do not show unless already assigned it
	private showBusinessLite(licensePlan: LicensePlan, agent: Agent) {
		const licensePlanId = Number(licensePlan.id);
		return (
			!CONSTANTS.licensePlans.businessLiteIds.includes(licensePlanId) || // not business lite, return it
			(CONSTANTS.licensePlans.businessLiteIds.includes(licensePlanId) && agent.hasSeparateBusinessLite())
		);
	}

	// do not show unless already assigned it
	private showBusinessNoCharge(licensePlan: LicensePlan, agent: Agent) {
		return (
			!(licensePlan.upfrontFee === 0 && licensePlan.monthlyFee === 0) || // not no charge, return it
			(licensePlan.upfrontFee === 0 && licensePlan.monthlyFee === 0 && agent.hasSeparateBusinessNoCharge())
		);
	}

	transform(licensePlans: LicensePlan[], agent: Agent): any {
		if (!licensePlans) {
			return licensePlans;
		}

		return _.uniqBy(licensePlans, l => l.name).filter(
			l => !l.parents?.length && this.showBusinessLite(l, agent) && this.showBusinessNoCharge(l, agent),
		);
	}
}
